<template>
  <transition name="slide">
    <div v-show="show()">
      <slot></slot>
    </div>
  </transition>
</template>

<script>
import { mapState } from 'redux-vuex';
import select from '@/store/selectors';

export default {
  data: mapState({
    isHidden: select.components.extendedBlock,
  }),
  methods: {
    show() {
      return !this.isHidden;
    },
  },
};
</script>

<style scoped lang="scss">
  .slide-leave-active,
  .slide-enter-active {
    transition: opacity .3s ease-in-out;
    overflow: hidden;
  }

  .slide-enter, .slide-leave-to {
    opacity: 0;
    width: 0;
  }

  .slide-leave-enter, .slide-enter-to {
    opacity: 1;
  }
</style>
